var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "survey-react-ui";
import { CreatorModelElement } from "../ModelElement";
import { QuestionAdornerViewModel } from "survey-creator-core";
var CellQuestionAdornerComponent = /** @class */ (function (_super) {
    __extends(CellQuestionAdornerComponent, _super);
    function CellQuestionAdornerComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CellQuestionAdornerComponent.prototype.createModel = function (props) {
        this.model = new QuestionAdornerViewModel(props.componentData, props.question, null);
    };
    CellQuestionAdornerComponent.prototype.getStateElement = function () {
        return this.model;
    };
    CellQuestionAdornerComponent.prototype.getUpdatedModelProps = function () {
        return ["question", "componentData"];
    };
    CellQuestionAdornerComponent.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { "data-sv-drop-target-survey-element": this.model.element.name, className: "svc-question__adorner" },
                React.createElement("div", { className: " svc-question__content--in-popup svc-question__content" }, this.props.element))));
    };
    return CellQuestionAdornerComponent;
}(CreatorModelElement));
export { CellQuestionAdornerComponent };
ReactElementFactory.Instance.registerElement("svc-cell-question", function (props) {
    return React.createElement(CellQuestionAdornerComponent, props);
});
